import { TableColumn } from '@shared/components/plain-table';

export const ESTATE_TABLE_COLUMNS: TableColumn[] = [
  {
    id: 'type',
    label: 'Type of Property',
    width: '15%',
  },
  {
    id: 'location_type',
    label: 'Property Type Detail',
    width: '15%',
  },
  {
    id: 'description',
    label: 'Property Description',
  },
  {
    id: 'value',
    label: 'Property Value',
    width: '13%',
  },
  {
    id: 'actions',
    label: 'Actions',
    width: '13%',
  },
];
